import { productType } from "./product-service";

interface APIGetConfig<T> {
  url: string;
  token: string;
  requestInfo?: RequestInit;
}
const branch = process.env.NEXT_PUBLIC_APP_BRANCH;
const apitwo = process.env.NEXT_PUBLIC_API_TWO;
const apitest = process.env.NEXT_PUBLIC_API_TEST;
const campaign = process.env.NEXT_PUBLIC_CAMPAIGN;
const campaignTest = process.env.NEXT_PUBLIC_CAMPAIGN_TEST;
const digilogger = process.env.NEXT_PUBLIC_DIGILOGGER_URL;
const digiloggerTest = process.env.NEXT_PUBLIC_DIGILOGGER_TEST_URL;
const base_user_rescue = process.env.NEXT_PUBLIC_USER_RESCUE_URL;
const base_url = branch === "test" ? apitest : apitwo;
const campaign_url = branch === "test" ? campaignTest : campaign;
const linkg_url = process.env.NEXT_PUBLIC_LINKG_URL;
const digilogger_url = digilogger; // branch === "test" ? digiloggerTest : digilogger;
const store_id = process.env.NEXT_PUBLIC_STORE_ID;
const shaparak_payment = process.env.NEXT_PUBLIC_SHAPARAK_PAYMENT;

//FUN API ROUTE
const apitwoFun = process.env.NEXT_PUBLIC_API_TWO_FUN;
const apitestFun = process.env.NEXT_PUBLIC_API_TEST_FUN;
const baseFunUrl = branch === "test" ? apitestFun : apitwoFun;

type RelatedType = "product_id" | "file_id";

export const API = {
  site: (withoutTrailingSlash: boolean = false) =>
    `https://www.digitoon.tv${withoutTrailingSlash ? "" : "/"}`,
  tv_site: "https://tv.digitoon.tv",
  club_site: `https://${
    branch !== "master" ? branch + "." : ""
  }digitoon.tv/club/`,
  digitoon_fun: `https://${
    branch !== "master" ? branch + "." : ""
  }digitoon.tv/fun`,
  radiotoon: `https://${
    branch !== "master" ? branch + "." : ""
  }digitoon.tv/radiotoon`,
  bazitoon: `https://${
    branch !== "master" ? branch + "." : ""
  }digitoon.tv/bazitoon`,
  request_search_tag: `${base_url}/search/${store_id}`,
  request_search_response: `${base_url}/search-response/`,
  request_related_response: `${base_url}/related-response/`,
  request_weekly_top_search: `${base_url}/weekly-top-searches/`,
  request_recently_user_search: `${base_url}/last-search-user/`,
  request_refresh_token: `${base_url}/refresh-token/`,
  request_dg_id: `${base_url}/api/v3/get-dg-id/`,
  request_linkg: `https://linkg-f.digitoon.ir/api/?campaign=415`,
  request_fetch_config: `${base_url}/api/v3/configs/${store_id}/web/`,
  request_fetch_packages: `${base_url}/api/v3/packages/${store_id}/web/`,
  request_fetch_market_packages: `${base_url}/api/v3/packages/${store_id}/market/`,
  request_bookmarks: `${base_url}/api/v3/bookmarks/`,
  request_limit_age: `${base_url}/user/user_limit_age/`,
  request_collection: `${base_url}/api/v3/web/collection/`,
  request_latest_blog: `${base_url}/api/v3/web/blog/latest/`,
  request_get_lock_product: `${base_url}/get_lock_product`,
  request_rest_operator: `${base_url}/api/v3/configs/8/WEB/`,
  request_pull_message: `${base_user_rescue}/offer-manager/api/v2/pull/`,
  request_rescue_log: `${base_user_rescue}/rescue-log/api/v2/pull/`,

  //FUN APIS
  get_likes: (id: number) => `${baseFunUrl}/api/v1/ugc/${id}/like/`,
  post_like: (id: number) => `${baseFunUrl}/api/v1/ugc/${id}/like/`,
  remove_like: (id: number) => `${baseFunUrl}/api/v1/ugc/${id}/like/`,

  post_limit_age: (ageId: number) =>
    `${base_url}/user/user_limit_age/${ageId}/`,
  toggle_bookmarks: (productId: number) =>
    `${base_url}/api/v3/bookmarks/${productId}/`,
  download: (fileId: number) => `${base_url}/api/v3/download-web/${fileId}/`,
  update_product_lock: (productId: number) =>
    `${base_url}/update_lock_product/${productId}/`,
  request_visited: (limit: number, offset: number) =>
    `${base_url}/user/watched_history/?limit=${limit}&offset=${offset}`,
  request_my_bests: () => `${base_url}/user/recommend_av`,
  request_server_time: `${base_url}/server-time/`,
  request_report: `${base_url}/logger/report-problem/`,
  request_category: (categoryId: number) =>
    `${base_url}/api/category/${store_id}/${categoryId}/`,
  request_AvFileLog: (fileId: number) =>
    `${base_url}/api/v3/avfile-logger/${fileId}/`,

  request_recommended: (dg_id: string) =>
    `${base_url}/api/v3/recommender/${dg_id}/`,

  request_paymanPayment: (sku: string) =>
    `${base_url}/payman-payment/${sku}/21/?bank_code=BOOMIR&is_web=true&is_web_request=1&url_prefix=http%3A%2F%2F${window.location.hostname}`,

  request_sadadPayment: (sku: string, prefixUrl?: string) =>
    `${base_url}/sadad-payment/${sku}/16?is_web=true&is_web_request=1&url_prefix=https://${hostnameAndPort()}${
      prefixUrl && "/" + prefixUrl
    }`,
  request_bankPayment: (sku: string, prefixUrl?: string) =>
    `${base_url}/bank_payment/${sku}/${shaparak_payment}?is_web_request=1&url_prefix=https://${hostnameAndPort()}${
      prefixUrl && "/" + prefixUrl
    }`,
  request_discount: (code: string) =>
    `${base_url}/discount/bank/?discount=${code}`,
  post_discount_voucher: (code: string, sku: string) =>
    `${base_url}/discount/consume_voucher/${sku}/?discount=${code}`,
  request_consume_discount: (code: string, sku: string, getwayId: number) =>
    `${base_url}/discount/consume_discount/${sku}/${getwayId}/?discount=${code}&is_web_request=1&url_prefix=http%3A%2F%2F${window.location.hostname}`,
  request_related: (id: number, type: RelatedType) =>
    `${base_url}/api/v3/web/related/?${type}=${id}`,
  request_promoted: (id: number) =>
    `${base_url}/api/v3/web/product/${id}/module/`,
  request_home_details: (category_id: number, page: number, limit: number) =>
    `${base_url}/api/v3/web/home/?category_id=${category_id}&page=${page}&limit=${limit}`,
  request_product_list: (categoryId: number, limit?: number) =>
    `${base_url}/api/v3/web/product-list/${categoryId}/?limit=${limit}`,
  request_product_details: (productId: number) =>
    `${base_url}/api/v3/web/product/${productId}/`,
  request_player_details: (productId: number, fileId?: number) =>
    `${base_url}/api/v3/web/product/${productId}/player/${
      fileId ? "?file_id=" + fileId : ""
    }`,
  request_player_int_details: (productId: number, fileId?: number) =>
    `${base_url}/api/v3/web/product/${productId}/player-int/${
      fileId ? "?file_id=" + fileId : ""
    }`,
  request_campaign: `${campaign_url}/api/ads/web/`,
  post_campaign: `${campaign_url}/api/watch-report/`,
  request_event_campaign: `${campaign_url}/api/event-logger/`,
  request_web_push_redirect: `${base_url}/api/v3/web/web-push-redirect/`,

  request_related_products: `${base_url}/api/v3/web/related/`,
  request_profile_with_active_subs: `${base_url}/profile?include_active_subs=true`,
  request_children_list: `${base_url}/get-children-list/`,

  request_miac_details: (fileId: number) =>
    `${base_url}/interactive-details/${fileId}/`,
  post_miac_submit: (fileId: number) =>
    `${base_url}/interactive-submit/${fileId}/`,
  get_suggested_product: `${base_url}/api/v3/suggested-products/`,
  post_favorite_products: `${base_url}/api/v3/favorite-products/`,
  request_provinces: `${base_url}/provinces/`,
  request_user_avatars: `${base_url}/user_avatars/`,
  post_user_avatars: (avatarId: number) =>
    `${base_url}/user_avatars/${avatarId}/`,
  post_profile: `${base_url}/profile`,
  post_login_google: `${base_url}/login_google/${store_id}`,
  mobile_login_step1: `${base_url}/mobile_login_step1/${store_id}`,
  proxy_mobile_login_step1: `api/mobile_login_step1`,
  mobile_login_step2: `${base_url}/mobile_login_step2/${store_id}`,
  proxy_mobile_login_step2: `/api/mobile_login_step2`,
  proxy_mobile_logout: `/api/mobile_logout`,
  remote_log: "http://localhost:4200/api/remote-log",
  get_netrecognitor: (ip: string) =>
    `https://netrecognitor.yaramobile.com/api/${ip}/`,
  get_recent_products: (category_id: number, from: number) =>
    `${base_url}/api/v3/ssg/products/?category_id=${category_id}&from=${from}`,
  get_all_products: (category_id: number) =>
    `${base_url}/api/v3/ssg/all-products/?category_id=${category_id}`,
  request_product_comments: (productId: number, limit: number) =>
    `${base_url}/comment/${productId}?limit=${limit}`,
  post_comment: (productId: number) => `${base_url}/comment/${productId}`,
  post_geolocation: `${digilogger_url}/api/v1/location/`,
  get_token_user: (user_id: number, device_id: string) =>
    `${base_url}/get-token-user/?user_id=${user_id}&device_id=${device_id}`,
  delete_vandar: (paymentId: number) =>
    `${base_url}/vandar/direct-debit/remove-sub/${paymentId}`,

  fetch: async function (url: string, requestInfo?: RequestInit) {
    const calculatedRequestInfo = {
      ...requestInfo,
      headers: {
        "Accept-Language": "fa-ir",
        "Content-Type": "application/json",
        ...requestInfo?.headers
      }
    };

    return fetch(url, calculatedRequestInfo);
  },

  fetchJson: async function <T>(url: string, requestInfo?: RequestInit) {
    const res = await API.fetch(url, requestInfo);
    if (!res.ok) return null;
    try {
      const data: T = await res.json();

      return data;
    } catch (e) {
      // console.log("error in fetching: ", e);
      return null;
    }
  },

  fetchText: async function (url: string, requestInfo?: RequestInit) {
    const res = await API.fetch(url, requestInfo);
    return res.text();
  },

  fetchAuth: async function <T>(config: APIGetConfig<T>) {
    const { url, token, requestInfo } = config;
    const addedRequestInfo = requestInfo
      ? {
          ...requestInfo,
          headers: {
            "Accept-Language": "fa",
            Authorization: `Token ${token}`,
            ...requestInfo.headers
          }
        }
      : null;
    return API.fetch(url, addedRequestInfo as RequestInit);
  },

  methodAuth: async function <T>(method: HttpMethods, config: APIGetConfig<T>) {
    const { url, token, requestInfo } = config;

    return API.fetchAuth({
      url,
      token,
      requestInfo: {
        ...requestInfo,
        method: method
      }
    });
  },

  getAuth: async function <T>(config: APIGetConfig<T>) {
    return API.methodAuth("GET", config);
  },

  postAuth: async function <T>(config: APIGetConfig<T>) {
    return API.methodAuth("POST", config);
  }
};

export type ResponseRange =
  | "informational"
  | "successful"
  | "redirection"
  | "client-error"
  | "server-error"
  | "unknown";
export const responseRange = (code: number): ResponseRange => {
  switch (true) {
    case 100 <= code && code <= 199:
      return "informational";
    case 200 <= code && code <= 299:
      return "successful";
    case 300 <= code && code <= 399:
      return "redirection";
    case 400 <= code && code <= 499:
      return "client-error";
    case 500 <= code && code <= 599:
      return "server-error";
    default:
      return "unknown";
  }
};
export type HttpMethods = "GET" | "POST" | "DELETE" | "PUT";
export interface UrlParam {
  param: string;
  value: string;
}
export const addParamToUrl = (url: string, param: string, value: string) =>
  url + (url.includes("?") ? "" : "?") + "&" + param + "=" + value;

export const addParamArrToUrl = (url: string, paramArr: UrlParam[]) => {
  const paramValues = paramArr.map(i => i.param + "=" + i.value).join("&");
  return url + (url.includes("?") ? "&" : "?") + paramValues;
};

export const createBannerUrl = (
  url: string,
  dg_id: string,
  isLoggedIn: boolean
) => {
  return addParamArrToUrl(url, [
    { param: "dg_id", value: dg_id },
    { param: "is_login", value: isLoggedIn ? "true" : "false" },
    { param: "platform", value: "web" }
  ]);
};

export const LIMIT = {
  total: 5000,
  steps: 10
};

export const hostnameAndPort = () =>
  window.location.hostname +
  (window.location.port ? ":" + window.location.port : "");
